import styled from 'styled-components'
import { colors, fonts } from 'client/styles'
import { BoardCodeBase } from 'client/components/Rooms/BoardCode/styles'
import { CapacityBase } from 'src/comps/Capacity/styles'

export const RoomInformationBase = styled.div`
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 8px;
  border: 2px solid ${colors.grey4};

  width: 100%;
`

export const RoomWrapper = styled.div`
  padding-block: 16px;
  padding-inline: 16px;
  ${BoardCodeBase} {
    font-size: 16px;

    text-transform: lowercase;
    ::first-letter {
      text-transform: uppercase;
    }
  }

  ${CapacityBase} {
    margin-block-end: 20px;
  }
`

export const TotalCost = styled.div`
  display: flex;
  background-color: ${colors.white};
  width: 100%;
  border-end-start-radius: 8px;
  border-end-end-radius: 8px;

  font-family: ${fonts.default};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  width: 100%;

  padding-block: 16px 12px;
  padding-inline: 16px;
  border-block-start: 1px solid ${colors.grey4};
`

export const Value = styled.span`
  color: ${colors.grey2};
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;

  padding-inline-start: 12px;
`

export const Footer = styled.div`
  padding-block: 0 16px;
  padding-inline: 16px 0;
  color: ${colors.grey2};
`

export const GreenCost = styled.span`
  color: ${colors.green4};
  text-transform: capitalize;
`
